<template>
<h1>Home view</h1>
  <h3 v-if="currentUser">Welcome {{ currentUser }}</h3>
  <!--div class="debug">
        <p>preferences prop : {{ preferences}}</p>
    </div>-->

  <!-- <div class="container">-->
  <Suspense>
    <template #default>
      <Watchlist></Watchlist>
    </template>


    <template #fallback> Loading... </template>
  </Suspense>
  <!--div>
    <h3>timer testing:</h3>
    <p>on = {{ timer.on }}</p>
    <p>lastTime = {{ timer.lastTime }}</p>
    <p>nowTime = {{ timer.nowTime }}</p>
    <p>interval = {{ timer.interval }}</p>
    <p>tick = {{  timer.tick }}</p>
    <button type="button" :onClick="timer.stopTimer">Stop Timer</button>
  </div-->

 

  <!-- </div> -->
  <div v-if="currentGroup === 'admin'">
    <FormBtn :name="'Admin Manage Customers'" @clicked="manageCustomers"></FormBtn>
  </div>

   <!--SeismicFetch></SeismicFetch-->

</template>

<script setup lang="ts">
import Watchlist from '@/components/Watchlist.vue'
import FormBtn from '@/components/form/Form-btn.vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores'
import router from '@/router'
import { onBeforeMount } from 'vue';

//import { useTimerStore }  from '@/stores/timer-store'
//import SeismicFetch from '@/components/Seismic-fetch.vue';
const usersStore = useUserStore()
const { currentUser, currentGroup } = storeToRefs(usersStore)
//const timer = useTimerStore();
//timer.startTimer();
//const cache = useCacheStore();
//const { initCache, ready } = useCacheStore();
//const { ready } = storeToRefs(cache);


function manageCustomers() {
  router.push('/customers/manage')
}

//onBeforeMount(()=>{
///  cache.initCache();
//})


</script>

<style lang="css" scoped>
/*div {
    border: 1px solid blue;
}*/

@media print {
  body {
    visibility: hidden;
  }

  #invoice-div {
    visibility: visible;
  }
}
</style>
